module.exports = __webpack_public_path__ + "img/hall-li2.8ce5d128.png";